<template>
  <v-container fluid class="investstock-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-investstock`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-finance</v-icon>
            Stock
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab-item
            :value="'tab-investstock'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Stock</p>
                      <v-text-field
                        class="mb-4"
                        type="Number"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'stockrank')"
                        v-bind:value="initvalue.stockrank"
                        placeholder="Stock Rank"
                        persistent-hint
                        single-line hint="Enter the stock rank">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'stockcode')"
                        v-bind:value="initvalue.stockcode"
                        placeholder="Stock Code"
                        persistent-hint
                        single-line hint="Enter the stock code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'stockname')"
                        v-bind:value="initvalue.stockname"
                        placeholder="Stock Name"
                        persistent-hint
                        single-line hint="Enter the stock name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=stock_types
                        :value="initvalue.stocktype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'stocktype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the stock type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'stockstatus')"
                          v-bind:label="initvalue.stockstatus"
                          v-model="initvalue.stockstatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                          to="/investstock/list"
                          replace
                          outlined
                          color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="editInvestStock()">
                          Save
                        </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onImageFile" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/investstock/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      filename: null,
      imageurl: undefined,
      errorindex: undefined,
      change_stock: {},
      upload_photo: {},
      initvalue: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      stock_types: ['Stock', 'CEF', 'ETF'],
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('InvestStock', ['isReceiving']),
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('InvestStock', ['getInvestStockRequest', 'updateInvestStockRequest','updateInvestStockImageRequest', 'updateInvestStockUnitRequest']),
    async editInvestStock() {
      this.change_stock._id = this.initvalue._id;
      await this.updateInvestStockRequest(this.change_stock);
      router.push('/investstock/list');
    },
    async editPhoto() {
      this.upload_photo._id = this.initvalue._id;
      await this.updateInvestStockImageRequest(this.upload_photo);
      router.push('/investstock/list');
    },
    updateChangedValue(value, field){
      this.change_stock[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },
    onImageFile(file) {
      if (!file) {return;}
      this.upload_photo.stockimage = file;
      this.upload_photo.imagename = file.name;
      this.createImage(file);
    },
  },

  async created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.stockimage;
    if(!this.initvalue._id) this.$router.push({ name: 'InvestStockList' });
    if(this.accounts.length==0) await this.getAccountsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
